import React from 'react';

/**
 * Mission 10 admin card — surface background + elevation, NO border
 * (decision #4: cards separate via background contrast). Functional borders
 * on inputs / table dividers stay where they are; this is for panels & tiles.
 */
export interface AdminCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** `subtle` = limestone-ish background, no shadow (nested/inset panels). */
  variant?: 'default' | 'subtle';
  /** Remove padding (when the card hosts its own full-bleed content, e.g. a table). */
  flush?: boolean;
}

export const AdminCard: React.FC<AdminCardProps> = ({
  variant = 'default',
  flush = false,
  className = '',
  children,
  ...rest
}) => {
  const cls = [
    'admin-card',
    variant === 'subtle' ? 'admin-card--subtle' : '',
    flush ? 'admin-card--flush' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
};
